import { render, staticRenderFns } from "./ComponentTester.vue?vue&type=template&id=d996fb60&scoped=true&"
import script from "./ComponentTester.vue?vue&type=script&lang=js&"
export * from "./ComponentTester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d996fb60",
  null
  
)

export default component.exports